export { getTrackLang, countryCodeToLangCode };

/**
 * Similar, but not equal, exist in mgg-epg, the only one more clone
 * and I must create a package.
 * @type {Map<string, string>}
 */
const mapCountryLanguage = new Map([
  [ 'ua', 'uk' ], // uk-UA
  [ 'ee', 'et' ], // et-EE
  [ 'kz', 'kk' ], // kk-KZ
  [ 'ge', 'ka' ], // ka-GE
  [ 'kg', 'ky' ], // ky-KG
]);

/**
 * Resolve country code to language code.
 * @param {string} countryCode
 * @return {string} ISO-639-1 language code
 */
function countryCodeToLangCode(countryCode) {
  return mapCountryLanguage.get(countryCode);
}

/**
 * @todo: import (and re-export) typedef from plugin audio
 * @param {AudioTrack|Subtitle} track
 * @return {string} lang
 */
function getTrackLang(track) {
  const options = [ getLang, extractLang, remapLegacyLang ];
  for (let i = 0; i < options.length; i++) {
    const lang = options[i](track);
    if (lang && lang.length === 2) {
      return lang;
    }
  }
  throw new Error('Unresolved language');
}

function getLang({ lang_iso_639_1 }) {
  return lang_iso_639_1;
}

function extractLang({ lang_tag = '' }) {
  return lang_tag.slice(0, 2);
}

function remapLegacyLang({ lang }) {
  return countryCodeToLangCode(lang);
}
